(function() {
  'use strict';
  
  let moveAttempts = 0;
  const maxAttempts = 50;
  
  function moveKlarnaWidget() {
    console.log('Tentative de déplacement Klarna #' + (moveAttempts + 1));
    
    // Chercher le widget Klarna avec l'attribut part
    const klarnaWidget = document.querySelector('[part="osm-container"]');
    const customContainer = document.getElementById('klarna-placement-custom');
    
    console.log('Widget trouvé:', klarnaWidget);
    console.log('Container trouvé:', customContainer);
    
    if (klarnaWidget && customContainer) {
      // Vérifier si déjà déplacé
      if (klarnaWidget.dataset.moved === 'true') {
        console.log('Widget déjà déplacé');
        return true;
      }
      
      try {
        // Déplacer le widget
        customContainer.appendChild(klarnaWidget);
        klarnaWidget.dataset.moved = 'true';
        
        // Ajouter un style pour s'assurer qu'il s'affiche bien
        klarnaWidget.style.display = 'block';
        klarnaWidget.style.width = '100%';
        
        console.log('✅ Widget Klarna déplacé avec succès!');
        return true;
      } catch (error) {
        console.error('Erreur lors du déplacement:', error);
      }
    }
    
    return false;
  }
  
  function attemptMove() {
    moveAttempts++;
    
    if (moveKlarnaWidget()) {
      return;
    }
    
    if (moveAttempts < maxAttempts) {
      setTimeout(attemptMove, 500);
    } else {
      console.warn('⚠️ Impossible de déplacer le widget Klarna après ' + maxAttempts + ' tentatives');
      
      // Debug final : lister tous les éléments Klarna trouvés
      console.log('Éléments trouvés avec [part="osm-container"]:', document.querySelectorAll('[part="osm-container"]'));
      console.log('Éléments trouvés avec [data-testid="credit-promotion-badge"]:', document.querySelectorAll('[data-testid="credit-promotion-badge"]'));
      console.log('Éléments contenant "klarna":', document.querySelectorAll('[class*="klarna"], [id*="klarna"]'));
    }
  }
  
  // Observer les mutations DOM avec les deux sélecteurs
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          // Vérifier avec part="osm-container"
          if (node.matches && node.matches('[part="osm-container"]')) {
            console.log('Widget Klarna détecté via observer (part)');
            setTimeout(moveKlarnaWidget, 100);
          }
          // Vérifier si le widget est dans les enfants
          else if (node.querySelector && node.querySelector('[part="osm-container"]')) {
            console.log('Widget Klarna détecté dans les enfants (part)');
            setTimeout(moveKlarnaWidget, 100);
          }
        }
      });
    });
  });
  
  // Démarrer
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptMove);
  } else {
    attemptMove();
  }
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
})();